/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CommSmsFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M3 8C3 5.79086 4.79086 4 7 4H17C19.2091 4 21 5.79086 21 8V12.5892C21 14.7983 19.2091 16.5892 17 16.5892H16.7632C16.487 16.5892 16.2632 16.813 16.2632 17.0892V19.8512C16.2632 20.2881 15.7422 20.5149 15.4224 20.2171L11.8143 16.8573C11.6292 16.685 11.3857 16.5892 11.1328 16.5892H7C4.79086 16.5892 3 14.7983 3 12.5892V8Z'
      fill='currentColor'
    />
  </React.Fragment>
)
